import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import {PencilSimple,Trash} from '@phosphor-icons/react'

import $ from "jquery";
import { API_URL } from "..";
const BusinessProfileLayer = () => {
  const {id} = useParams();
  const [imagePreview, setImagePreview] = useState(
    "assets/images/user-grid/user-grid-img13.png"
  );
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [singleData, setSingleData] = useState({});
  const [singleDataJob, setSingleDataJob] = useState([]);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [currentUser,setCurrentUser] = useState({})
  // Toggle function for password field
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };
  const fetchSingle = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    setCurrentUser(user)
    let headersList = {
      Accept: "*/*",
      
    };
    let response = await fetch(`${API_URL}/api/affiliates/fetch-affiliate/${id}`, {
      method: "GET",
      headers: headersList,
    });

    let data = await response.json();
    setSingleData(data);
  };
  const fetchSingleJobs = async () => {
    let headersList = {
      'Accept': "*/*",
      // "User-Agent": "Thunder Client (https://www.thunderclient.com)",
    };

    let response = await fetch(`${API_URL}/api/jobs/${id}`, {
      method: "GET",
      headers: headersList,
    });

    let data = await response.json();
    setSingleDataJob(data);
    console.log(data);
  };
  React.useEffect(() => {
    fetchSingle();
    fetchSingleJobs();
  }, [1]);
  // Toggle function for confirm password field
  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  const readURL = (input) => {
    if (input.target.files && input.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(input.target.files[0]);
    }
  };
  React.useEffect(() => {
    const table = $("#dataTable").DataTable({
      pageLength: 10,
      data: singleDataJob,
      columns: [
        {
          data: "id",
        },
        {
          data: "fullname", // Indicates this column is generated using the `render` function
          render: function (data, type, row) {
            // Return HTML string for buttons
            return `
              <a href="/lead-view/${row.id}" style="color:blue" data-id="${row.id}">${data}</a>
            `;
          },
          title: 'Customer Name', // The header for the column
         
        },
        {
          data: "address",
        },
        {
          data: "phone",
        },
        {
          data: "driver.name", // Indicates this column is generated using the `render` function
          render: function (data, type, row) {
            // Return HTML string for buttons
            return `
              <span data-id="${row.id}">${data ? data : 'N/a'}</span>
            `;
          },
          title: 'Driver Name', // The header for the column
         
        },
       
        {
          data: "status",
        }
      ],
    });
    return () => {
      table.destroy(true);
    };
  }, [singleDataJob]);
  
  return (
    <div className="row gy-4">
      <div className="col-lg-12">
        <div className="user-grid-card position-relative border radius-16 overflow-hidden bg-base h-100">
          <div className="pb-24 ms-16 mb-24 me-16 ">
            <div className="border row border-top-0 border-start-0 border-end-0">
              {/* <img
                                src="assets/images/user-grid/user-grid-img14.png"
                                alt=""
                                className="border br-white border-width-2-px w-200-px h-200-px rounded-circle object-fit-cover"
                            /> */}
            <div className="col-md-6">

              <h6 className="mb-0 mt-16">{singleData?.business_name}</h6>
              {/* <p>{JSON.stringify(singleData)}</p> */}
              <span className="text-secondary-light mb-16">
                {singleData?.email}
              </span>
            </div>
            {
            currentUser.role === 'user' ? 
            null:


            <div className="col-md-6 text-end" style={{paddingTop:20}}>
              <Link to={`/edit-affiliates/${id}`} className="btn btn-info">
                            <PencilSimple size={20}/>
              </Link>
            </div>
            }
            </div>
            <div className="mt-24">
              <h6 className="text-xl mb-16">Business Info</h6>
              <ul>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Phone Number
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {singleData?.phone}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Services
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {singleData?.services_provided}
                  </span>
                </li>

                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Address
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {singleData?.address}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Description
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {singleData?.description}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-12">
        <div className="card basic-data-table">
          <div className="card-header">
            <div class="row">
              <h5 className="col-md-6 card-title mb-0">Recent Jobs</h5>
              {/* <Link class="col-md-6 text-end" to={'/add-job'} >Add New</Link> */}
            </div>
          </div>
          <div className="card-body">
           {
            singleDataJob.length == 0 ? 
            null :
            <table
            className="table bordered-table mb-0"
            id="dataTable"
            data-page-length={10}
          >
            <thead>
              <tr>
                <th scope="col">
                  <div className="form-check style-check d-flex align-items-center">
                    
                    <label className="form-check-label">ID</label>
                  </div>
                </th>
                <th scope="col">Customer Name</th>

                <th scope="col">Location</th>
                <th scope="col">Phone</th>
                <th scope="col">Driver</th>

                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
            </tbody>
          </table>
           }
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessProfileLayer;
